import {priority, wcfclient} from '@priority-software/priority-proto-api/lib';
import {getAdditionalProps} from '../core/loginProps';
import {common} from '@priority-software/priority-proto-api/lib/nform';

export const setServerStoreData = async (
    StoreMap: {[k: string]: common.IConstant} | null,
    CurrentScopeUser: boolean,
    CurrentScopeCompany: boolean
) => {
    /*
        data will be stored as follow:
        key = NameSpace/Action/{language_ID}/Feature
        example:
        Recent Items key will be saved as:
        System/Load/{language_ID}/RecentItems
    */
    try {
        const res = await wcfclient.dataStoreSet(
            new priority.netitems.ngtw.DataStoreSetRq({
                Properties: getAdditionalProps(),
                StoreMap,
                CurrentScopeUser,
                CurrentScopeCompany
            })
        );

        if (res.Messages.length > 0) {
            res.Messages.forEach(item => {
                console.error(item);
            });
        }
    } catch (e) {
        throw Error((e as Error).message);
    }
};

export const getServerStoreData = async (
    Keys: Array<string>,
    CurrentScopeCompany: boolean = true,
    CurrentScopeUser: boolean = false
) => {
    /*
        data will be stored as follow:
        key = NameSpace/Action/{language_ID}/Feature
        example:
        Recent Items key will be saved as:
        System/Load/{language_ID}/RecentItems
    */
    try {
        const res = await wcfclient.dataStoreGet(
            new priority.netitems.ngtw.DataStoreGetRq({
                Keys,
                CurrentScopeCompany,
                CurrentScopeUser,
                Properties: getAdditionalProps()
            })
        );

        if (res.Messages.length > 0) {
            res.Messages.forEach(item => {
                console.error(item);
            });
        }

        return res.StoreMap;
    } catch (e) {
        throw Error((e as Error).message);
    }
};
